// extracted by mini-css-extract-plugin
module.exports = {"background_wrapper":"filter-card_background_wrapper__a08jl","card":"filter-card_card__bY9J2","selected":"filter-card_selected__qJc2B","title":"filter-card_title__CFYi1"};